import { ImageLoader } from 'next/image';

import { allowedSizes, getComputedAttribute } from './shared';

/**
 * Kontainer/ImageBank ids
 *
 * 6821 Webshop 96x192 png
 * 6834 Webshop 384x768 png
 * 6835 Webshop 750x1500 png
 * 6836 Webshop 1080x2160 png
 * 6837 Webshop 1920x3840 png
 * 6838 Webshop 3840x7680 png
 * 7018 Webshop 96x192 jpg
 * 7019 Webshop 384x768 jpg
 * 7020 Webshop 750x1500 jpg
 * 7021 Webshop 1080x2160 jpg
 * 7022 Webshop 1920x3840 jpg
 * 7023 Webshop 3840x7680 jpg
 *
 * // NEW WEBP IDS - to be used instead of the above.
 * 22395 Webshop 96x192 webp
 * 22396 Webshop 384x768 webp
 * 22397 Webshop 750x1500 webp
 * 22398 Webshop 1080x2160 webp
 * 22399 Webshop 1920x3840 webp
 * 22400 Webshop 3840x7680 webp
 */

const conversionMapWebP: Record<number, number> = {
	96: 22395,
	384: 22396,
	750: 22397,
	1080: 22398,
	1920: 22399,
	3840: 22400,
};

export const imageBankLoader: ImageLoader = ({ src, width, quality = 75 }) => {
	const parts = src.split('/');
	// We'll force the output to be WebP no matter what the input is, because WebP is smaller, and we like small images.
	// See RFG-3146 for more.
	const srcWithFormatForcedToWebP = src.replace(/\.(jpg|jpeg|png)$/, '.webp');
	const isWithSingleHash = parts.length === 6;
	const computedWidth = getComputedAttribute(allowedSizes, width);

	// Not used anymore, but kept for reference
	// const ext = parts[parts.length - 1].split('.')[1];

	const params = new URLSearchParams();

	if (isWithSingleHash) {
		params.append('d', String(conversionMapWebP[computedWidth]));
	} else {
		params.append('w', String(computedWidth));
		// Image bank requires a height to work, while next/image doesn't.
		// Setting the height to a larger number than the width
		// will make the width decide the image dimensions.
		params.append('h', String(computedWidth * 2));
		params.append('q', String(quality));
	}

	// Use "src" here if you want the original format (jpg/png), but I'll bet you don't.
	return srcWithFormatForcedToWebP + '?' + params.toString();
};
